import axios from 'axios'

let refreshRequest = null
let isAlreadyFetchingAccessToken = false

const HTTP = axios.create({
    baseURL: (process.env.NODE_ENV === 'production' ? 'https://extraservices.com.ua/api/' : 'http://dev.extraservices.com.ua:3003/api/'),
})

const HTTP_AUTH = axios.create({
    // baseURL: (process.env.NODE_ENV === 'production' ? 'https://auth.yugcontract.ua/api/' : 'http://dev.auth.yugcontract.ua:3055/api/'),
    baseURL: (process.env.NODE_ENV === 'production' ? 'https://auth.yugcontract.ua/api/' : 'https://auth.yugcontract.ua/api/'),
})


// Add a request interceptor
HTTP.interceptors.request.use(config => {
        const authToken = localStorage.authToken ? JSON.parse(localStorage.authToken) : ''
        const refreshToken = localStorage.refreshToken ? JSON.parse(localStorage.refreshToken) : ''
        if (!authToken) {
            return config
        } else {
            const newConfig = {
                headers: {},
                ...config
            }
            newConfig.headers.Authorization = `Bearer ${authToken}`
            return newConfig;
        }

    },
    (error) => Promise.reject(error)
);
HTTP_AUTH.interceptors.request.use(config => {
        const authToken = localStorage.authToken ? JSON.parse(localStorage.authToken) : ''
        const refreshToken = localStorage.refreshToken ? JSON.parse(localStorage.refreshToken) : ''
        if (!authToken) {
            return config
        } else {
            const newConfig = {
                headers: {},
                ...config
            }
            newConfig.headers.Authorization = `Bearer ${authToken}`
            return newConfig;
        }

    },
    (error) => Promise.reject(error)
);

// Add a response interceptor
HTTP.interceptors.response.use(async response => {
    return response;
}, async error => {
    const originalRequest = error.config
    let authToken = localStorage.authToken ? JSON.parse(localStorage.authToken) : ''
    let refreshToken = localStorage.refreshToken ? JSON.parse(localStorage.refreshToken) : ''
    if (error.response && error.response.status === 401 && !isAlreadyFetchingAccessToken && refreshToken) {
        isAlreadyFetchingAccessToken = true
        if (!refreshRequest) {
            refreshRequest = HTTP_AUTH.post("/auth/refresh", {
                refreshToken: refreshToken
            })
        }
        //Принимаем новую пару токенов
        const {
            data
        } = await refreshRequest

        if (data.content.token && data.content.refreshToken) {
            authToken = data.content.token
            refreshToken = data.content.refreshToken
            localStorage['authToken'] = JSON.stringify(authToken)
            localStorage['refreshToken'] = JSON.stringify(refreshToken)
            originalRequest.headers.Authorization = `Bearer ${authToken}`
            refreshRequest = null
            isAlreadyFetchingAccessToken = false
        }
        return HTTP(originalRequest)
    } else {
        return Promise.reject(error)
    }
})

// Add a response interceptor
HTTP_AUTH.interceptors.response.use(async response => {
    return response;
}, async error => {
    const originalRequest = error.config
    let authToken = localStorage.authToken ? JSON.parse(localStorage.authToken) : ''
    let refreshToken = localStorage.refreshToken ? JSON.parse(localStorage.refreshToken) : ''
    if (error.response && error.response.status === 401 && !isAlreadyFetchingAccessToken && refreshToken) {
        isAlreadyFetchingAccessToken = true
        if (!refreshRequest) {
            refreshRequest = HTTP_AUTH.post("/auth/refresh", {
                refreshToken: refreshToken
            })
        }
        //Принимаем новую пару токенов
        const {
            data
        } = await refreshRequest

        if (data.content.token && data.content.refreshToken) {
            authToken = data.content.token
            refreshToken = data.content.refreshToken
            localStorage['authToken'] = JSON.stringify(authToken)
            localStorage['refreshToken'] = JSON.stringify(refreshToken)
            originalRequest.headers.Authorization = `Bearer ${authToken}`
            refreshRequest = null
            isAlreadyFetchingAccessToken = false
        }
        return HTTP_AUTH(originalRequest)
    } else {
        return Promise.reject(error)
    }
})

export {
    HTTP,
    HTTP_AUTH
}
